<div class="custom-panel table-panel flex flex-grow">
    <mat-card class="flex flex-grow flex-column">
        <mat-card-header>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="cst-panel-header">
                <mat-card-title *ngIf="header; else loggedOut"><h3>{{ header }}</h3></mat-card-title>
                <ng-template #loggedOut>
                    <ng-content select="[table-panel-header]"></ng-content>
                </ng-template>
                <div *ngIf="newOneTitle" fxLayout="row" fxLayoutAlign="flex-end center">
                    <button mat-button (click)="createNew()" [ngClass]="{'upper': true, 'cst-button-good': !compTableFlag, 'cst-button-bad-border': compTableFlag}" class="upper cst-button-good">{{ newOneTitle }}</button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content class="mat-card-content flex flex-grow flex-column">
            <ng-content select="[panel-body]"></ng-content>
        </mat-card-content>
        <!-- <mat-card-actions>
        </mat-card-actions> -->
    </mat-card>    
</div>
